function baseURL() {
  if (process.env.NODE_ENV === "development") {
    return "http://modelexperience.local:3004";
  }
  return window.location.origin.replace("new.", "");
}

const websiteURL = baseURL();
export default websiteURL;
